import { ComponentRef, Injector, PLATFORM_ID, SimpleChanges, ViewContainerRef } from '@angular/core';
import { DynamicComponentHelper } from './dynamic-component.helper';
import { DynamicComponentConfigWithSSRToggle } from './interfaces';
import { isPlatformServer } from '@angular/common';
import * as i0 from "@angular/core";
/**
 * DynamicComponentDirective is a structural directive which should be used on ng-container.
 * <ng-container *dynamicComponent="{id:'selector',inputs,outputs}"></ng-container>
 * Based on the passed id, it will check registry if a replacement component for that ID is available.
 * Then it will either render the found replacement or fall back to the default component (specified by @ReplaceableComponent).
 */
export let DynamicComponentDirective = /*#__PURE__*/(() => {
  class DynamicComponentDirective {
    set _config(config) {
      this.config = {
        inputs: {},
        outputs: {},
        ...config
      };
    }
    get excludeSSR() {
      return isPlatformServer(this.ngPlatformId) && this.config?.excludeSSR;
    }
    constructor(injector, vcr, ngPlatformId) {
      this.injector = injector;
      this.vcr = vcr;
      this.ngPlatformId = ngPlatformId;
      this.defaultComponentContext = {};
      this.componentBindings = [];
    }
    ngOnInit() {
      if (!this.config) throw new Error('DynamicComponentdirective failed: no config available!');
      if (!this.config.component) throw new Error('DynamicComponentdirective failed: no component info was passed!');
    }
    ngOnChanges(changes) {
      if (this.excludeSSR) return;
      if (!changes?._config) return;
      if (changes._config.currentValue.component && changes._config.currentValue.component !== changes._config.previousValue?.component) {
        setTimeout(() => {
          this.componentInfo = DynamicComponentHelper.getComponentInfoFromInput(this.config);
          this.setupCustomComponent(this.componentInfo);
        });
      } else if (changes._config.currentValue.inputs) {
        // TODO: without deep diff, the if check will always result in true
        DynamicComponentHelper.updateComponentInputValues(this.componentRef, this.componentInfo, this.config.inputs);
      }
    }
    /*********************************
     * Handling of custom component
     *********************************/
    clearBindings() {
      this.componentBindings.forEach(binding => binding.next(true));
      this.componentBindings = [];
    }
    setupCustomComponent(componentInfo) {
      this.clearBindings();
      // this.removeComponent();
      const {
        componentRef,
        destroyBindings
      } = DynamicComponentHelper.makeCustomComponent(this.config, this.injector, this.vcr, this.componentRef);
      this.componentBindings.push(destroyBindings);
      this.componentRef = componentRef;
    }
    static {
      this.ɵfac = function DynamicComponentDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || DynamicComponentDirective)(i0.ɵɵdirectiveInject(i0.Injector), i0.ɵɵdirectiveInject(i0.ViewContainerRef), i0.ɵɵdirectiveInject(PLATFORM_ID));
      };
    }
    static {
      this.ɵdir = /*@__PURE__*/i0.ɵɵdefineDirective({
        type: DynamicComponentDirective,
        selectors: [["", "dynamicComponent", ""]],
        inputs: {
          _config: [0, "dynamicComponent", "_config"]
        },
        features: [i0.ɵɵProvidersFeature([]), i0.ɵɵNgOnChangesFeature]
      });
    }
  }
  return DynamicComponentDirective;
})();